import React from "react";

import { Flex, FlexProps } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { Button } from "ui/Button/Button";

export type StockCorrectorShortcutProps = {
  onConfirm: () => void;
  onEdit: () => void;
  canConfirm: boolean;
} & FlexProps;

export function StockCorrectorShortcut({
  onConfirm,
  onEdit,
  canConfirm,
  ...rest
}: StockCorrectorShortcutProps) {
  const intl = useIntl();
  return (
    <Flex gap="s100" {...rest}>
      <Button disabled={!canConfirm} variant="secondary" onClick={onConfirm} isFullWidth>
        {intl.formatMessage({
          id: "pages.stock-corrections.shortcut.confirm",
          defaultMessage: "Confirm",
        })}
      </Button>
      <Button variant="secondary" onClick={onEdit} isFullWidth>
        {intl.formatMessage({
          id: "pages.stock-corrections.shortcut.edit",
          defaultMessage: "Edit",
        })}
      </Button>
    </Flex>
  );
}
